// Copyright (c) 2018 Deere & Company

import t from 'tcomb';

const PipIndicator = t.struct({
    color: t.String,
    status: t.String
}, {
    name: 'PipIndicator',
    strict: true
});

export const getDefaultState = () => new PipIndicator({
    color: '',
    status: ''
});

export default PipIndicator;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/pip-indicator.js